import api from './api';

export const adminPostService = {
    getPosts: (params) => {
        return api.get('/admin/posts', { params });
    },
    getPost: (id) => {
        return api.get(`/admin/posts/${id}`);
    },
    createPost: (data) => {
        return api.post('/admin/posts', data, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    },
    updatePost: (id, data) => {
        // Need to use POST with _method=PUT for file uploads in Laravel if updating with file
        // Or just PUT if no file, but FormData usually requires POST + _method
        data.append('_method', 'PUT');
        return api.post(`/admin/posts/${id}`, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    },
    deletePost: (id) => {
        return api.delete(`/admin/posts/${id}`);
    }
};
